require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-once-synonymous-with-new-york-warehouse-conversions.json") })
        }
      }, "path---news-once-synonymous-with-new-york-warehouse-conversions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-once-synonymous-with-new-york-warehouse-conversions!./.cache/json/news-once-synonymous-with-new-york-warehouse-conversions.json
// module id = 834
// module chunks = 231608221292675